import { render, staticRenderFns } from "./TotalValuesCard.vue?vue&type=template&id=67ffc47d&scoped=true"
import script from "./TotalValuesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalValuesCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TotalValuesCard.vue?vue&type=style&index=0&id=67ffc47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ffc47d",
  null
  
)

export default component.exports